import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { specializationAPI, contactAPI } from '../services/api';
import API_BASE_URL from '../config/api';
import LoadingScreen from '../components/LoadingScreen';
import { useLang } from '../context/LanguageContext';
import { Helmet } from 'react-helmet-async';
import '../styles/ContactModal.css';


const HomeReact = () => {
 
  const navigate = useNavigate();
  const { nl } = useLang();
  const L = (obj, field) => (nl && obj?.[field + '_nl']) || obj?.[field] || '';
  const [specializations, setSpecializations] = useState([]);
  const [heroData, setHeroData] = useState(null);
  const [announcementData, setAnnouncementData] = useState(null);
  const [announcementClosed, setAnnouncementClosed] = useState(false);
  const [blogsData, setBlogsData] = useState(null);
  const [servicesData, setServicesData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [statsData, setStatsData] = useState(null);
  const [activeTab, setActiveTab] = useState('all');
  const [blogs, setBlogs] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [reviewSectionActive, setReviewSectionActive] = useState(true);
  const [sectionLabels, setSectionLabels] = useState({
    servicesTitle: 'Our Services',
    servicesSubtitle: 'Innovative, scalable, and secure solutions tailored to accelerate your digital transformation and business growth.',
    productsTitle: 'Our Products',
    productsSubtitle: 'SEO-friendly, scalable, and innovative digital solutions designed to meet your organization\'s unique business needs.',
    contactSalesText: 'Contact Sales'
  });
  const [loading, setLoading] = useState(true);
  const [seoData, setSeoData] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);
  const [contactFormData, setContactFormData] = useState({
    firstName: '', lastName: '', email: '', phone: '', company: '', service: '', message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const recaptchaRef = useRef();
  
  useEffect(() => {
  fetch(`${API_BASE_URL}/api/seo/home`)
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setSeoData(data.data);
      }
    })
    .catch(err => console.error("SEO fetch error:", err));
}, []);


  useEffect(() => {
    specializationAPI.getAll()
      .then(data => {
        console.log('Specializations data:', data);
        setSpecializations(data);
      })
      .catch(err => console.error('Error loading specializations:', err));

    fetch(`${API_BASE_URL}/api/homepage`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          if (data.data.heroSection) setHeroData(data.data.heroSection);
          if (data.data.announcement) setAnnouncementData(data.data.announcement);
          if (data.data.blogsSection) setBlogsData(data.data.blogsSection);
          if (data.data.statsSection) setStatsData(data.data.statsSection);
          if (data.data.sectionLabels) setSectionLabels(prev => ({ ...prev, ...data.data.sectionLabels }));
        }
      })
      .catch(err => console.error('Error loading homepage data:', err));

    fetch(`${API_BASE_URL}/api/services`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setServicesData(data.data);
      })
      .catch(err => console.error('Error loading services:', err));

    fetch(`${API_BASE_URL}/api/services/categories`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setCategoriesData(data.data);
      })
      .catch(err => console.error('Error loading categories:', err));

    fetch(`${API_BASE_URL}/api/blogs`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setBlogs(data.data.slice(0, 4));
        setLoading(false);
      })
      .catch(err => {
        console.error('Error loading blogs:', err);
        setLoading(false);
      });

    fetch(`${API_BASE_URL}/api/client-reviews/active`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setReviews(data.data);
      })
      .catch(err => console.error('Error loading reviews:', err));

    fetch(`${API_BASE_URL}/api/client-reviews/section`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setReviewSectionActive(data.data.sectionIsActive);
      })
      .catch(err => console.error('Error loading review section status:', err));
  }, []);

 
 

  console.log("hero data", heroData);
  console.log("accent text", heroData?.accentText);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const getFilteredServices = () => {
    if (activeTab === 'all') return servicesData;
    const category = categoriesData.find(cat => cat.slug === activeTab);
    if (!category) return [];
    return servicesData.filter(s =>
      String(s.categoryId) === String(category._id) ||
      (!s.categoryId && s.category === category.name)
    );
  };

  if (loading) return <LoadingScreen />;

  console.log("fileter data",getFilteredServices)

  return (
    <div>
      <Helmet>
        <title>{seoData?.title || 'Aurelia Technology'}</title>
        {seoData?.description && <meta name="description" content={seoData.description} />}
        {seoData?.keywords && <meta name="keywords" content={seoData.keywords} />}
        {seoData?.canonicalUrl && <link rel="canonical" href={seoData.canonicalUrl} />}
        <meta property="og:title" content={seoData?.ogTitle || seoData?.title || 'Aurelia Technology'} />
        <meta property="og:description" content={seoData?.ogDescription || seoData?.description || ''} />
        {seoData?.ogImage && <meta property="og:image" content={seoData.ogImage} />}
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoData?.twitterTitle || seoData?.ogTitle || seoData?.title || 'Aurelia Technology'} />
        <meta name="twitter:description" content={seoData?.twitterDescription || seoData?.ogDescription || seoData?.description || ''} />
        {(seoData?.twitterImage || seoData?.ogImage) && <meta name="twitter:image" content={seoData.twitterImage || seoData.ogImage} />}
      </Helmet>
    
      {/* Announcement Strip */}
      {announcementData && announcementData.isActive && !announcementClosed && (
        <div className="announcement-strip">
          <div className="strip-container">
            <p>
              {announcementData.text && <strong>{nl ? (announcementData.text_nl || announcementData.text) : announcementData.text}</strong>}
              {announcementData.linkText && (
                <> - <a href={announcementData.linkUrl || '#'}>{nl ? (announcementData.linkText_nl || announcementData.linkText) : announcementData.linkText}</a></>
              )}
            </p>
            <button className="close-btn" onClick={() => setAnnouncementClosed(true)}>
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>
      )}

      {/* Hero Section */}
      {(!heroData || heroData.isActive !== false) && (
        <section className="hero">
          <div className="container hero-grid">
            <div className="hero-content">
              <h1>
                {(() => {
                  const title = (nl ? heroData?.mainTitle_nl : null) || heroData?.mainTitle || 'AN AI & BLOCKCHAIN DEVELOPMENT COMPANY';
                  const accents = (nl ? heroData?.accentText_nl?.trim() : null) || heroData?.accentText?.trim();
                  
                  
                  
                  if (!accents) return title;
                  
                  const words = accents.split(',').map(w => w.trim()).filter(w => w);
                  console.log('Words to highlight:', words);
                  
                  if (words.length === 0) return title;
                  
                  const regex = new RegExp(`(${words.join('|')})`, 'gi');
                  const parts = title.split(regex);
                  console.log('Split parts:', parts);
                  
                  return (
                    <span>
                      {parts.map((part, i) => {
                      
                        const isAccent = words.some(w => w.toLowerCase() === part.toLowerCase());
                        console.log(`Part "${part}" is accent:`, isAccent);
                        return isAccent ? (
                          <span key={i} style={{
                            background: 'linear-gradient(90deg, #FFB53D, #D4A14E)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text',
                            display: 'inline-block'
                          }}>{part}</span>
                        ) : <span key={i}>{part}</span>;
                      })}
                    </span>
                  );
                })()}
              </h1>
              <p dangerouslySetInnerHTML={{
                __html: ((nl ? heroData?.subTitle_nl : null) || heroData?.subTitle || 'Crafting Next-Gen Software Solutions for Startups and Enterprises<br>Cultivate the vision. Shape the future.')
              }} />
              <div className="hero-cta">
                <button className="btn-secondary" onClick={() => setShowContactModal(true)}>{nl ? (sectionLabels.contactSalesText_nl || sectionLabels.contactSalesText) : sectionLabels.contactSalesText}</button>
              </div>
            </div>
            <div className="hero-image">
              {heroData?.heroImage && <img src={heroData.heroImage} alt="Team collaboration" />}
            </div>
          </div>
        </section>
      )}

      {/* Services Section */}
      {sectionLabels.servicesIsActive !== false && (
      <section className="specialization-section" style={{ backgroundColor: '#FBFBF9' }}>
        <div className="container">
          <div className="section-header">
            <h2>{nl ? (sectionLabels.servicesTitle_nl || sectionLabels.servicesTitle) : sectionLabels.servicesTitle}</h2>
            <p>{nl ? (sectionLabels.servicesSubtitle_nl || sectionLabels.servicesSubtitle) : sectionLabels.servicesSubtitle}</p>
            <div className="section-divider">
              <div className="divider-line"></div>
              <div className="divider-dots">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </div>
            </div>
          </div>
          
          <div className="services-cards">
            {specializations.length > 0 ? specializations.map((spec) => (
              <div key={spec._id} className="service-card">
                <div className="service-image">
                  <img src={spec.image} alt={(nl && spec.title_nl) || spec.title} />
                </div>
                <h3>{(nl && spec.title_nl) || spec.title}</h3>
                {spec.sections && spec.sections.length > 0 ? (
                  <ul className="spec-key-points">
                    {spec.sections.slice(0, 3).map((section, index) => (
                      <li key={index}>{(nl && section.sectionTitle_nl) || section.sectionTitle}</li>
                    ))}
                  </ul>
                ) : (
                  <p>{(nl && spec.description_nl) || spec.description}</p>
                )}
                <a href={`/services`} className="spec-link" onClick={(e) => { e.preventDefault(); navigate(`/services`); }}>Read More <i className="fas fa-arrow-right"></i></a>
              </div>
            )) : (
              <div className="loading-message">
                <p>Loading services...</p>
              </div>
            )}
          </div>
        </div>
      </section>
      )}

      {/* Products Section */}
      {sectionLabels.productsIsActive !== false && (
      <section id="services" className="services-section" style={{ backgroundColor: '#FBFBF9' }}>
        <div className="container">
          <div className="section-header">
            <h2>{nl ? (sectionLabels.productsTitle_nl || sectionLabels.productsTitle) : sectionLabels.productsTitle}</h2><p>{nl ? (sectionLabels.productsSubtitle_nl || sectionLabels.productsSubtitle) : sectionLabels.productsSubtitle}</p>
            <div className="section-divider">
              <div className="divider-line"></div>
              <div className="divider-dots">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </div>
            </div>
          </div>
          
          <div className="services-tabs">
            {categoriesData.map(cat => (
              <button key={cat.slug} className={`tab-btn ${activeTab === cat.slug ? 'active' : ''}`} onClick={() => handleTabClick(cat.slug)}>
                {(nl && cat.name_nl) || cat.name}
              </button>
            ))}
          </div>
          
          <div className="services-content">
            <div className="services-cards">
              {activeTab === 'all' ? (
                getFilteredServices().map(service => (
                  <div key={service._id} className="service-card">
                    <div className="service-image">
                      <img src={service.image || 'https://via.placeholder.com/300x200'} alt={service.title} />
                    </div>
                    <h3>{(nl && service.title_nl) || service.title}</h3>
                    <p>{(nl && service.excerpt_nl) || service.excerpt}</p>
                    <a href={`/${(nl && service.slug_nl) || service.slug}`} className="spec-link" onClick={(e) => { e.preventDefault(); navigate(`/products/${(nl && service.slug_nl) || service.slug}`); }}>Read More <i className="fas fa-arrow-right"></i></a>
                  </div>
                ))
              ) : (
                getFilteredServices().flatMap(service => 
                  service.sections?.map((section, idx) => (
                    <div key={`${service._id}-${idx}`} className="service-card">
                      {section.image && (
                        <div className="service-image">
                          <img src={section.image} alt={section.title} />
                        </div>
                      )}
                      <h3>{(nl && section.title_nl) || section.title}</h3>
                      <p>{(nl && (section.subtitle_nl || section.content_nl?.replace(/<[^>]*>/g, '').substring(0, 150) + '...')) || section.subtitle || section.content?.replace(/<[^>]*>/g, '').substring(0, 150) + '...' || 'No description'}</p>
                      <a href={`/${(nl && service.slug_nl) || service.slug}`} className="spec-link" onClick={(e) => { e.preventDefault(); navigate(`/products/${(nl && service.slug_nl) || service.slug}`); }}>Read more  <i className="fas fa-arrow-right"></i></a>
                    </div>
                  )) || []
                )
              )}
            </div>
          </div>
        </div>
      </section>
      )}

      {/* News and Updates Section */}
      {(!blogsData || blogsData.isActive !== false) && (
        <section id="solutions" className="news-updates-section">
          <div className="container">
            <div className="section-header">
              <h2>Blog & Articles</h2>
              <p>Stay informed with the latest industry insights, expert articles, company news, and technology updates to keep your business ahead of the curve.</p>
              <div className="section-divider">
                <div className="divider-line"></div>
                <div className="divider-dots">
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </div>
              </div>
            </div>
            
            <div className="solutions-grid">
              {(blogsData?.selectedBlogs && blogsData.selectedBlogs.length > 0 
                ? blogsData.selectedBlogs 
                : blogs
              )
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                .slice(0, 3)
                .map(blog => (
                <div key={blog._id} className="solution-card">
                  <div className="solution-image">
                    <img src={blog.image || 'https://via.placeholder.com/300x200'} alt={blog.title} />
                  </div>
                  <div className="solution-content">
                    <span className="blog-date">{new Date(blog.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                    <h3>{blog.title}</h3>
                    <p>{blog.excerpt}</p>
                    <a href={`/blog-post/${blog._id}`} className="spec-link" onClick={(e) => { e.preventDefault(); navigate(`/blog-post/${blog._id}`); }}>Read More <i className="fas fa-arrow-right"></i></a>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="blog-cta">
              <a href="/blog" className="spec-link" onClick={(e) => { e.preventDefault(); navigate('/blog'); }}>
                View All Blogs <i className="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
        </section>
      )}

      {/* Testimonials Section */}
      {reviewSectionActive && (
      <section className="testimonials-section" style={{ backgroundColor: '#FBFBF9' }}>
        <div className="container">
          <div className="section-header">
            <h2>Our Clients’ Reviews</h2>
            <p>Real feedback from our valued clients showcasing trust, performance, and successful partnerships that drive business growth.</p>
            <div className="section-divider">
              <div className="divider-line"></div>
              <div className="divider-dots">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </div>
            </div>
          </div>
          
          <div className="testimonials-grid">
            {reviews.length > 0 ? reviews.map((review) => (
              <div key={review._id} className="testimonial-card">
                <div className="testimonial-content">
                  <i className="fas fa-quote-left"></i>
                  <p>"{review.review}"</p>
                </div>
                <div className="testimonial-author">
                  <div className="author-info">
                    <h4>{review.name}</h4>
                    {review.position && <p>{review.position}{review.company && ` at ${review.company}`}</p>}
                  </div>
                </div>
              </div>
            )) : (
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <i className="fas fa-quote-left"></i>
                  <p>"No reviews available yet."</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      )}

      {/* Stats Section */}
      {statsData && statsData.isActive && (
        <section className="stats-section" style={{ 
            backgroundImage: "url('/images/Group9.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>
          <div className="container">
            <div className="stats-row">
              {statsData.stats?.filter(stat => stat.isActive).sort((a, b) => a.order - b.order).map((stat, index) => (
                <div key={index} className="stat">
                  <span className="stat-number">{stat.number}{stat.suffix || ''}</span>
                  <span className="stat-label">{nl ? (stat.label_nl || stat.label) : stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Contact Modal */}
      {showContactModal && (
        <div className="modal-overlay" onClick={() => setShowContactModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowContactModal(false)}>&times;</button>
            <h3>Contact Sales</h3>
            <form className="contact-form" onSubmit={async (e) => {
              e.preventDefault();
              if (process.env.REACT_APP_RECAPTCHA_SITE_KEY && !captchaValue) {
                alert('Please complete the reCAPTCHA verification');
                return;
              }
              setSubmitting(true);
              try {
                await contactAPI.submit({ ...contactFormData, captcha: captchaValue });
                alert('Message sent successfully!');
                setContactFormData({ firstName: '', lastName: '', email: '', phone: '', company: '', service: '', message: '' });
                setCaptchaValue(null);
                if (recaptchaRef.current) recaptchaRef.current.reset();
                setShowContactModal(false);
              } catch (error) {
                alert('Error sending message. Please try again.');
              } finally {
                setSubmitting(false);
              }
            }}>
              <div className="form-row">
                <div className="form-group">
                  <label>First Name *</label>
                  <input type="text" value={contactFormData.firstName} onChange={(e) => setContactFormData({...contactFormData, firstName: e.target.value})} required />
                </div>
                <div className="form-group">
                  <label>Last Name *</label>
                  <input type="text" value={contactFormData.lastName} onChange={(e) => setContactFormData({...contactFormData, lastName: e.target.value})} required />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Email Address *</label>
                  <input type="email" value={contactFormData.email} onChange={(e) => setContactFormData({...contactFormData, email: e.target.value})} required />
                </div>
                <div className="form-group">
                  <label>Phone Number</label>
                  <input type="tel" value={contactFormData.phone} onChange={(e) => setContactFormData({...contactFormData, phone: e.target.value})} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Company Name</label>
                  <input type="text" value={contactFormData.company} onChange={(e) => setContactFormData({...contactFormData, company: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Service Interest *</label>
                  <select value={contactFormData.service} onChange={(e) => setContactFormData({...contactFormData, service: e.target.value})} required>
                    <option value="">Select a service</option>
                    <option value="ai">AI Development</option>
                    <option value="blockchain">Blockchain Development</option>
                    <option value="cloud">Cloud Solutions</option>
                    <option value="mobile">Mobile Development</option>
                    <option value="web">Web Development</option>
                    <option value="bot">Bot Development</option>
                    <option value="consulting">Consulting</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label>Message *</label>
                <textarea rows="3" value={contactFormData.message} onChange={(e) => setContactFormData({...contactFormData, message: e.target.value})} required></textarea>
              </div>
              {process.env.REACT_APP_RECAPTCHA_SITE_KEY && (
                <div className="form-group">
                  <ReCAPTCHA ref={recaptchaRef} sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} onChange={setCaptchaValue} />
                </div>
              )}
              <button type="submit" className="submit-btn" disabled={submitting}>
                {submitting ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                    Sending...
                  </>
                ) : (
                  'Send Message'
                )}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeReact;